<template>
  <div class="bigBox">
    <div class="bigBox-title">通行记录</div>
    <div class="box1">
      <div class="box1-l">
        <div class="box1-l-title">
          <div>通行数据</div>
          <div>
            <el-date-picker
              @change="timeChange"
              size="mini"
              style="width:12vw"
              v-model="timeS"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
        <div class="box1-l-cont" id="chart1"></div>
        <div class="tip1">
          <div></div>
            正常
        </div>
        <div class="tip2">
          <div></div>
            异常
        </div>
      </div>
      <div class="box1-r">
        <div class="box1-r-title">
          <div>季度数据</div>
          <div>
            <el-date-picker
              @change="time1Change"
              v-model="time1"
              value-format="yyyy"
              type="year"
              placeholder="选择年">
            </el-date-picker>
          </div>
        </div>
        <div class="box1-r-cont" id="chart2"></div>
      </div>
    </div>
    <div class="box2">
      <div class="box2-title">
        <div class="box2-title-l">
          <el-input @change="getData" clearable v-model="personName" style="width:12.5vw;margin-right:1.125vw" size="small" placeholder="员工姓名" prefix-icon="el-icon-search" ></el-input>
          <el-input @change="getData" clearable v-model="idNo" style="width:12.5vw;margin-right:1.125vw" size="small"  placeholder="身份证号" prefix-icon="el-icon-search"></el-input>
          <el-select @change="getData" clearable  style="width:12.5vw;margin-right:1.125vw" size="small" v-model="flag" placeholder="状态">
            <el-option  label="正常" value="2"></el-option>
            <el-option  label="异常" value="1"></el-option>
          </el-select>
          <el-button style="background: #3871E5;" size="small" type="primary" @click="getData">搜索</el-button>
        </div>
        <div class="box2-title-r">
          <el-button style="background: #3871E5;" size="small" type="primary" @click="enter">更多</el-button>
        </div>
      </div>
      <div class="box2-cont">
        <el-table :data="tableList" height="30vh" border :header-cell-style="tableHeadStyle">
          <el-table-column
            label="序号"
            type="index"            
            width="50"                  
          ></el-table-column>
          <el-table-column label="姓名" width="70">
            <template slot-scope="scope" >
              <div>{{ scope.row.name}}</div>
            </template>
          </el-table-column>
          <el-table-column label="身份证">
            <template slot-scope="scope" >
              <div>{{ scope.row.idNo}}</div>
            </template>
          </el-table-column>
          <el-table-column label="设备ID">
            <template slot-scope="scope" >
              <div>{{ scope.row.imei}}</div>
            </template>
          </el-table-column>
          <el-table-column label="通行体温" width="80">
            <template slot-scope="scope" >
              <div
                :style="scope.row.temperature>37.5?'color: #f00;':'color: #23D715;'"
              >{{ scope.row.temperature||0}}°c</div>
            </template>
          </el-table-column> 
          <el-table-column label="健康码">
            <template slot-scope="scope">
              <img :src="scope.row.codeImg" style="height: 6vh" />
            </template>
          </el-table-column> 
          <el-table-column label="核酸状态">
            <template slot-scope="scope">
              <div v-if="scope.row.signName == '阴性'">
                <img style="width: 2vw" src="../../../assets/image/newAnKang/yin11.png">
                <p style="color: #23d715;">已过{{scope.row.timeSpan}}天</p>
              </div>
              <div v-else-if="scope.row.signName == '阳性'">
                <img style="width: 2vw" src="../../../assets/image/newAnKang/yang.png">
                <p style="color: #E32932;">已过{{scope.row.timeSpan}}天</p>
              </div>
              <div v-else>
                <p style="color: #bebebe;">暂无核酸</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="途径地" width="70">
            <template slot-scope="scope" >
              <div>{{ scope.row.tripAddress||'无'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="行程状态" width="80">
            <template slot-scope="scope" >
              <div v-if="scope.row.tripStatus==0">无风险</div>
              <div v-else-if="scope.row.tripStatus==1">有风险</div>
              <div v-else>无</div>
            </template>
          </el-table-column> 
          <el-table-column label="通行照片">
            <template slot-scope="scope">
              <img
                v-if="scope.row.photoFile!=''"
                :src="scope.row.photoFile"
                style="width:70px;height:90px;"
              />
              <div
                v-else
                style="width:70px;height:90px;background: #ddd;display: flex;align-items: center;justify-content: center;"
              >暂无图片</div>
            </template>
          </el-table-column>
          <el-table-column label="通行时间">
            <template slot-scope="scope" >
              <div>{{ scope.row.date}}</div>
            </template>
          </el-table-column>       
          <el-table-column label="备注" width="160">
            <template slot-scope="scope">
              <div class="remarks">{{ scope.row.remarks}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70">
            <template slot-scope="scope">
              <div><el-button style="background: #3871E5;padding:7px 8px;" size="mini" type="primary" @click="openRm(scope.row)">编辑</el-button></div>
            </template>
          </el-table-column>             
        </el-table>
        <el-dialog
          title="编辑"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          width="30%">
          <el-form label-width="65px">
            <el-form-item label="备注">
              
              <el-input
                type="textarea"
                :autosize="{ minRows: 8}"
                placeholder="请输入内容"
                maxlength="200"
                show-word-limit
                v-model="remarks">
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="queRen">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
  export default {
    data() {
      return {
        id:'',
        remarks:'',
        dialogVisible:false,
        timeS:[util.myTime.timeBefore(new Date(),7),util.myTime.getCurTime()],
        value: '',
        options: [],
        tableList:[],
        base:base.url,
        attendType:[],
        personName:'',
        status:'',
        idNo:'',
        time1:'',
        flag:'',
        date:util.myTime.getCurTime()
      }
    },
    mounted(){
      this.time1 = util.myTime.getYear() + ''
      this.getDict()
      this.findStrangerTimeSlotHealthStatistics()
      setTimeout(()=>{
        // this.echarts1()
      },1000)
      this.findQuarterStrangerStatistics()
    },
    methods:{
      queRen(){
        let that = this
        myHttp.updateAttendRemarksById({
          id:this.id,
          remarks:this.remarks,
          projectId:util.session.get('groupId')
        }).then(res=>{
          if(res.data.code == 200){
            this.$message.success(res.data.msg)
            that.dialogVisible=false
            that.getData()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      openRm(row){
        console.log('id',row)
        this.id=row.id
        this.remarks=row.remarks || ''
        this.dialogVisible = true
      },
      echarts2(data,num){
        console.log(data)
        this.$echarts.init(document.querySelector('#chart2')).dispose();
        let chart2 = this.$echarts.init(document.querySelector('#chart2'))
        chart2.setOption({
          title:{
            text:'访客人数'+num+'人',
            left: 'center',
            top: 'center'
          },
          color:['#6DCCE2','#07B7FF','#377DDE','#6AACF4'],
          series: [
            {
              label: {
                show: true,
                position: "inner",
                formatter: "{b}{c}人",
              },
              name: 'Access From',
              type: 'pie',
              radius: ['47%', '70%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: '#fff',
                borderWidth: 5
              },
              data: data
            }
          ]
        })
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          chart2.resize();
        });
      },
      findQuarterStrangerStatistics(){
        myHttp.findQuarterStrangerStatistics({
          projectId:util.session.get('groupId'),
          year:this.time1
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            let data = [
              {name:'一季度',value:0},
              {name:'二季度',value:0},
              {name:'三季度',value:0},
              {name:'四季度',value:0}
            ]
            let list = res.data.data.quarterStrangerStatistics
            list.forEach(item=>{
              data.forEach(item1=>{
                if(item.quarter==item1.name){
                  item1.value = item.personCount
                }
              })
            })
            let num = 0
            data.forEach(item=>{
              num = num+item.value
            })
            setTimeout(()=>{
              this.echarts2(data,num)
            },500)
          }
        })
      },
      echarts1(name,hao,huai){
        this.$echarts.init(document.querySelector('#chart1')).dispose();
        let chart1 = this.$echarts.init(document.querySelector('#chart1'))
        chart1.setOption({
          grid: {
            left: '5%', // 可以决定图形画布距离左侧的位置
            right: '5%', // 可以决定图形画布距离右侧的位置
            bottom: '10%',
            containLabel: true
          },
          width:'80%',
            xAxis: {
              axisLine: {
                lineStyle: {
                type: 'dashed',
                color: '',
                width: '1'
                }
              },
              splitLine:{
                show: true, //让网格显示
                lineStyle: {//网格样式
                color:['#4D6EB1'], //网格的颜色
                width:1, //网格的宽度
                type:'dashed' //网格是实实线，可以修改成虚线以及其他的类型
                }
              },
              type: 'category',
              data: name
            },
            yAxis: {
              minInterval:1,
              type: 'value',
              axisLine: {
                lineStyle: {
                  type: 'dashed',
                  color: '',
                  width: '1'
                }
              },
              splitLine:{
                    show: true,
                    lineStyle: {
                      color:['#4D6EB1'],
                      width:1,
                      type:'dashed'
                    }
                },
            },
            color:['#5E92E5','#FF0000'],
            series: [
              {
                data: hao,
                type: 'bar',
                itemStyle:{
                  normal:{
                    label:{
                      formatter:function(val){
                        if(true){
                          return `${val.value}人`
                        }
                      },
                    show:true,
                    position:'top',
                    textStyle:{
                      fontWeight:"bolder",
                      fontSize:"12",
                      color:"#4D6EB1"
                    }
                    }
                  }
                }
              },
              {
                data: huai,
                type: 'bar',
                itemStyle:{
                  normal:{
                    label:{
                      formatter:function(val){
                        if(true){
                          return `${val.value}人`
                        }
                      },
                    show:true,
                    position:'top',
                    textStyle:{
                      fontWeight:"bolder",
                      fontSize:"12",
                      color:"#D00810"
                    }
                    }
                  }
                }
              }
            ]
        })
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          chart1.resize();
        });
      },
      findStrangerTimeSlotHealthStatistics(){
        myHttp.findStrangerTimeSlotHealthStatistics({
          projectId:util.session.get('groupId'),
          startTime:this.timeS[0],
          endTime:this.timeS[1],
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            let list = res.data.data.strangerTimeSlotHealthStatistics
            let nameList = []
            let hao = []
            let huai = []
            list.forEach((item,index)=>{
              nameList.push(item.time)
              hao.push(item.normalCount)
              huai.push(item.abnormalCount)
            })
            setTimeout(()=>{
        this.echarts1(nameList,hao,huai)
      },1000)
            
          }
        })
      },
      time1Change(){
        console.log(this.time1)
        this.findQuarterStrangerStatistics()
      },
      timeChange(){  
        if(this.timeS==null){
          this.timeS = ['','']
        }else{
          if(util.myTime.getdayByDate(this.timeS[0],this.timeS[1])>6){
            this.$message.error('最大间隔时间为7天！')
          }else{
            this.findStrangerTimeSlotHealthStatistics()
          }
        }
        console.log(this.timeS)
      },
      getDict() {
        var that = this
        myHttp.getDictByType({
          type: 'attend_type'
        }).then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dictList||[]
            for(var i=0;i<list.length;i++){
              list[i].text = list[i].label
            }
            that.attendType = list
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
      //获取类型
    filterSatus(str) {
      var list = this.attendType
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (str == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
      getData(){
        let that = this
        myHttp.findStrangerInOutPage({
          projectId:util.session.get('groupId'),
          pageSize:50,
          pageNum:1,
          date:this.date,
          status:this.status,
          idNo:this.idNo,
          personName:this.personName,
          flag:this.flag
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            let list = res.data.data.strangerInOutPage.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].photoFile = list[i].photoFile && list[i].photoFile != '' ? base.httpCtx + list[i].photoFile : ''
              list[i].typeName = that.filterSatus(list[i].status)
              if (list[i].healthLevel == '1') {
                list[i].codeImg = require('../../../assets/image/new/green.png')
              } else if (list[i].healthLevel == '2') {
                list[i].codeImg = require('../../../assets/image/new/yellow.png')
              } else if (list[i].healthLevel == '3') {
                list[i].codeImg = require('../../../assets/image/new/red.png')
              } else if (
                list[i].healthLevel == '4' ||
                list[i].healthLevel == '0'
              ) {
                list[i].codeImg = require('../../../assets/image/new/no.png')
              }
              
              // list[i].idcardPhoto = list[i].idcardPhoto && list[i].idcardPhoto!=''?base.httpCtx+list[i].idcardPhoto:''
              // list[i].createDate = list[i].createDate && list[i].createDate!=''?list[i].createDate.split(' ')[0]:''
              // list[i].age = util.myTime.getAge(list[i].birthday)
            }
            this.tableList = list
          }
        })
      },
      enter(){
        this.$router.push({
          path:'/accessRecordList'
        })
      },
      tableHeadStyle({ row, column, rowIndex, columnIndex }){
        if(rowIndex == 0){
          return `background-color: #EEE;`
        }
      },
    }
  }
</script>

<style scoped>
.remarks{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
::v-deep .cell>div{
  font-size: .7292vw;
  text-align: start;
}
.bigBox{
  width: 100%;
  height: 100%;
  padding: 0 24px 0 16px;
}
.bigBox-title{
  height: 4vh;
  display: flex;
  align-items: center;
  justify-content: left;
  color: #666666;
  font-size: .8333vw;
  margin-bottom: .3646vw;
}
.box1{
  display: flex;
  justify-content: space-between;
  margin-bottom: .8333vw;
}
.box1-l{
  height: 45vh;
  background: #FFFFFF;
  border-radius: .3125vw;
  width: 69.3%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.tip1{
  position:absolute;
  right: 5%;
  top: 27%;
  color: #666666;
  font-size: .7292vw;
  display: flex;
  align-items: center;
}
.tip1>div{
  width: 1.0417vw;
  height: 1.0417vw;
  background: #5E92E5;
  margin-right: .5208vw;
}
.tip2>div{
  width: 1.0417vw;
  height: 1.0417vw;
  background: #FF0000;
  margin-right: .5208vw;
}
.tip2{
  position:absolute;
  right: 5%;
  top: 37%;
  color: #666666;
  font-size: .7292vw;
  display: flex;
  align-items: center;
}
.box1-r{
  height: 45vh;
  background: #FFFFFF;
  border-radius: .3125vw;
  width: 29.7%;
  display: flex;
  flex-direction: column;
}
.box1-l-title{
  display: flex;
  align-items: center;
  padding: .8333vw;
  position: relative;
}
.box1-l-title>div:nth-child(1){
  color: #666666;
  font-size: .8333vw;
  margin-left: .4167vw;
  position: relative;
}
.box1-l-title>div:nth-child(1)::before{
  position: absolute;
  left: -0.625vw;
  top: 0;
  content:"" ;
  background-color: #4D6EB1;
  width: .2083vw;
  height: 100%;
}
.box1-l-title>div:nth-child(2){
  position: absolute;
  left: 38%;
  content:"" ;
}
.box1-r-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .8333vw;
}
.box1-r-title>div:nth-child(1){
  color: #666666;
  font-size: .8333vw;
  margin-left: .4167vw;
  position: relative;
}
.box1-r-title>div:nth-child(1)::before{
  position: absolute;
  left: -0.625vw;
  top: 0;
  content:"" ;
  background-color: #4D6EB1;
  width: .2083vw;
  height: 100%;
}
.box1-r-title>div:nth-child(2){
  
}
.box1-l-cont{
  flex: 1;
}
.box1-r-cont{
  flex: 1;
}
.box2{
  height: 38vh;
  margin-top: .8333vw;
  background-color: #fff;
  box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
  border-radius: .3125vw;
  display: flex;
  flex-direction: column;
}
.box2-title{
  display: flex;
  justify-content: space-between;
  padding: .5208vw;
  border-bottom: .0521vw solid #E4E7EE;
}
.box2-title-l{
  display: flex;
}
.box2-cont{
  flex: 1;
  padding: .5208vw;
}
::v-deep .cell{
  font-size: .7292vw !important;
  text-align: start !important;
}
</style>